import BaseTotal from '../BaseTotal';

const BottomTotal = (props) => <BaseTotal pt={4} pb={4} bg="ui.infoBackground" {...props} />;

BottomTotal.propTypes = {
  ...BaseTotal.propTypes,
};

export default BottomTotal;
